<template>
  <div class="the-header-dropdown">
    <el-dropdown :hide-timeout="800" @command="handleDropDownCommand">
      <span class="el-dropdown-link">
        <img class="header-avatar" src="/static/img/common/user.png">
        <span class="user-name">{{ realname }}</span>
        <i class="el-icon-arrow-down el-icon--right" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">
          注销用户
        </el-dropdown-item>
        <el-dropdown-item v-if="!isShow" command="setPSD">
          修改密码
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      dialog-size="small"
      :visible.sync="isDialog"
      title="修改密码"
    >
      <div
        class="password"
        @keydown.enter="handleConfirm"
      >
        <div class="password-item">
          <span>旧密码：</span>
          <base-input
            v-model="password.oldpassword"
            type="password"
            clearable
          />
        </div>
        <div class="password-item">
          <span>新密码：</span>
          <base-input
            v-model="password.newpassword"
            type="password"
            clearable
          />
        </div>
        <div class="password-item">
          <span>确认新密码：</span>
          <base-input
            v-model="password.confirmpassword"
            type="password"
            clearable
          />
        </div>
      </div>
      <span slot="footer">
        <base-button
          color="blue"
          @click="handleCancel"
        >
          取 消
        </base-button>
        <base-button
          color="blue"
          bg-color
          @click="handleConfirm"
        >确 定</base-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { computed } from 'vue-function-api'
import { mapActions } from 'vuex'
import { roleNames } from '@/config.js'

// import BaseDialog from '../components/BaseDialog'
import BaseInput from '@/components/BaseInput'
import BaseButton from '@/components/BaseButton'

export default {
  name: 'TheHeaderDropdown',
  components: {
    // BaseDialog,
    BaseInput,
    BaseButton,
  },
  data () {
    return {
      isDialog: false,
      password: {},
      realname: this.$store.state.realname,
      isShow: false,
    }
  },
  // setup(props, { root }) {
  //   let isDialog = computed(() => false)

  //   function handleDropDownCommand(type) {
  //     type === 'logout' && root.$store.dispatch('pageLogout')
  //     type === 'setPSD' && (isDialog = computed(() => true))
  //   }

  //   const realname = computed(() => root.$store.state.realname)

  //   return {
  //     realname,
  //     handleDropDownCommand,
  //     isDialog,
  //   }
  // },
  mounted () {
    this.getRoles()
  },
  methods: {
    ...mapActions(['pageLogout', 'changePassword']),
    handleDropDownCommand (type) {
      type === 'logout' && this.pageLogout()
      type === 'setPSD' && (this.isDialog = true)
    },
    /**
     *@description               确定密码修改
     */
    async handleConfirm () {
      const { oldpassword, newpassword, confirmpassword } = this.password

      // if (!oldpassword || !newpassword || !confirmpassword) {
      //   this.$message({
      //     message: '密码不能为为空',
      //     type: 'warning',
      //   })
      //   return
      // }
      let tip = {
        oldpassword: '旧密码',
        newpassword: '新密码',
        confirmpassword: '确认新密码',
      }

      for (let k in tip) {
        if (!this.password[k]) {
          this.$message({
            message: `${tip[k]}不能为空`,
            type: 'warning',
          })
          return
        }
      }

      if (newpassword.length < 6) {
        this.$message({
          message: '新密码不能少于6位',
          type: 'warning',
        })
        return
      }

      if (newpassword !== confirmpassword) {
        this.$message({
          message: '确认新密码与新密码不一致',
          type: 'warning',
        })
        return
      }

      const params = {
        oldpassword,
        newpassword,
        confirmpassword,
      }

      const res = await this.changePassword(params)

      this.$notify({
        message: res.msg,
        type: res.code === 'success' ? 'success' : 'error',
      })

      res.code === 'success' && this.pageLogout()
    },
    // 打开修改密码弹窗
    handleCancel () {
      this.isDialog = false
    },
    getRoles () {
      let roles = this.$store.state.roles.map(({ name }) => name)
      this.isShow = roles.includes(roleNames.admin)
    },
  },
}
</script>

<style lang="less" scoped>
.the-header-dropdown {
  position: absolute;
  top: 20px;
  right: 100px;
  // float: right;
  // margin-top: 20px;
  // margin-right: 100px;
  .el-dropdown-link {
    color: #fff;
    cursor: pointer;

    .header-avatar {
      vertical-align: -5px;
      // width: 38px;
      // height: 38px;
      margin-right: 14px;
    }

    .user-name {
      color: #eee;
      // color: rgba(255, 255, 255, 0.7);
    }
  }
  /deep/ .el-dialog{
    .el-dialog__header{
      padding: 0px;
      height: 40px;
      line-height: 40px;
      background-color: #272d32;
      .el-dialog__title{
        margin-left: 25px;
        color: #fff;
        font-size: 15px;
      }
    }
    .el-dialog__headerbtn{
      top: 6px;
      .el-dialog__close{
        color: #fff;
        font-size: 30px;
      }
    }
    .el-dialog__body{
      padding: 0;
      color: #333;
      font-size: 15px;
    }
    .password {
      width: 80%;
      margin: 30px auto 0;
      .password-item {
        display: flex;
        margin-bottom: 20px;
        > span {
          display: inline-block;
          min-width: 100px;
          text-align: right;
        }
      }
    }
  }
}
</style>
